import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGES,
  normalizeLanguage,
} from "./constants";

export function useAppLanguage() {
  const { i18n } = useTranslation();

  const language = useMemo(() => {
    const currentLanguage = i18n.language || DEFAULT_LANGUAGE;
    return normalizeLanguage(currentLanguage);
  }, [i18n.language]);

  const setLanguage = useCallback(
    async (nextLanguage) => {
      const normalized = normalizeLanguage(nextLanguage);

      if (typeof window !== "undefined") {
        window.localStorage.setItem(LANGUAGE_STORAGE_KEY, normalized);
      }

      await i18n.changeLanguage(normalized);
    },
    [i18n],
  );

  return {
    language,
    setLanguage,
    supportedLanguages: SUPPORTED_LANGUAGES,
  };
}
